<template>
  <div></div>
</template>

<script>
export default {
  data: () => ({
    
  }),
  computed: {
    providerId() {
      return this.$route.params.providerId
    },
    target() {
      return this.$route.query.target
    },
    code() {
      return this.$route.query.otp
    },
    layoutProviderName() {
      return this.$store.getters["base/layoutProviderName"];
    },
    storeName() {
      return this.$store.getters['member/storeName'];
    },
    storeId() {
      return this.$store.getters['member/storeId'];
    },
    storeList() {
      return this.$store.getters['member/memberStores']
    },
  },
  mounted() {
    setTimeout(() => {
      this.init()
    }, 1000)
  },
  methods: {
    async init() {
      if (!this.target || !this.code) {
        this.$snotify.error(
          '缺少必要參數target或code',
          '邀請連結不正確'
        )
        return
      }

      if (this.storeList.length == 0) {
        this.$router.push({
          name: 'store-register',
          params: {
            providerId: this.providerId,
          },
          query: {
            forceCreate: true,
          },
        })
      }
      
      this.$apopup.base({
        title: `來自${this.layoutProviderName}的合作邀請`,
        width: '550px',
        bodySlot: () => import('@/modules/store/views/inviteCooperate/inviteCooperatePopup.vue'),
        applyCallback: (storeId) => {
          if (!storeId) {
            this.$router.push({
              name: 'store-register',
              params: {
                providerId: this.providerId,
              },
              query: {
                forceCreate: true,
              },
            })
            return
          }
          this.acceptInvite(storeId)
        },
      })
    },
    async handleError(error, storeId) {
      const status = error.status
      console.warn('Error accepting invite:', error)
      if (status === 400) {
        this.$snotify.error(
          '參數錯誤或缺失，請檢查邀請連結。',
          '合作失敗'
        )
      }
      else if (status === 403) {
        this.$snotify.error(
          '連結已失效或驗證碼錯誤，請聯繫供應商重新取得邀請連結。',
          '合作失敗'
        )
        this.$store.dispatch(`member/switchSelectedStore`, storeId)
        this.$root.$emit(`uploadCooperateProvider`)
        await this.$nextTick()
        this.$router.replace({
          name: 'store-info',
          params: { providerId: this.providerId },
        })
      } else if (status === 404) {
        this.$snotify.error(
          window.eagleLodash.get(error, 'data.message'),
          '合作失敗'
        )
        this.$store.dispatch(`member/switchSelectedStore`, storeId)
        this.$root.$emit(`uploadCooperateProvider`)
        await this.$nextTick()
        this.$router.replace({
          name: 'store-cooperation-list',
          params: { providerId: this.providerId },
        })
      } else if (status === 409) {
        this.$snotify.warning(
          `您已與該供應商合作中，無需重複加入。`,
          '操作警告'
        )
        this.$store.dispatch(`member/switchSelectedStore`, storeId)
        this.$root.$emit(`uploadCooperateProvider`)
        await this.$nextTick()
        this.$router.replace({
          name: 'store-cooperation-list',
          params: { providerId: this.providerId },
        })
      } else {
        this.$snotify.error(
          error.message || '發生未知錯誤',
          '錯誤'
        )
      }
    },
    async acceptInvite(storeId) {
      this.$store.dispatch('loading/active')
      try {
        const result = await this.$api.collection.storeApi.cooperateByLink(
          this.providerId,
          storeId,
          this.target,
          this.code
        )
        this.$tokenStore.set(result.token)
        this.$store.dispatch('loading/close')
        this.$snotify.success(
          '畫面即將重新整理',
          '加入供應商成功！'
        )
        await this.$nextTick()
        this.$store.dispatch(`member/switchSelectedStore`, storeId)
        this.$router.replace({
          name: 'store-cooperation-list',
          params: { providerId: this.providerId },
        })
        await this.$helper.delay(2)
        window.location.reload()
      } catch (error) {
        this.handleError(error, storeId)
      } finally {
        this.$store.dispatch('loading/close')
      }
    },
  },
}
</script>

<style lang="sass" scoped></style>
